import React from "react"
import ContextProvider from "./src/context/MainContext"
import ShopifyProvider from "./src/context/ShopifyContext"

export const wrapRootElement = ({ element }) => (
  <ContextProvider>
    <ShopifyProvider>{element}</ShopifyProvider>
  </ContextProvider>
)
